@if (legend()) {
    <legend class="ap-heading-3">{{ legend() }}</legend>
}
<ng-content></ng-content>
